import { call, put, takeEvery } from "redux-saga/effects";
import { GetRolesSuccess, GetRolesFailure, GetCatalogSuccess, GetCatalogFailure } from "../../actions/Rbac";
import { GET_ROLES, GET_CATALOG } from "../../constants/Rbac";
import getRequest from "../../../util/APIHelperGet";
import { baseUrl } from "../../../util/APIBaseUrl";

export const fetchRolesRequest = async () => {
  return await getRequest(`${baseUrl}/v4/roles`, false);
};

export const fetchCatalogRequest = async () => {
  return await getRequest(`${baseUrl}/v4/rbac/catalog`, false);
};

function* fetchRoles(params) {
  try {
    const response = yield call(fetchRolesRequest, params);
    yield put(GetRolesSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(GetRolesFailure(error));
  }
}

function* fetchCatalog(params) {
  try {
    const response = yield call(fetchCatalogRequest, params);
    yield put(GetCatalogSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(GetCatalogFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(GET_ROLES, fetchRoles);
  yield takeEvery(GET_CATALOG, fetchCatalog);
}
